import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

const useStyles = createUseStyles(() => ({
  tableContainer: {
    "& thead": {
      display: "none",
    },
    "& table": {
      borderSpacing: `0 ${theme.spacing(2)}px`,
      borderCollapse: "separate",
      minWidth: "820px !important",
    },
    "& td:nth-child(1), & th:nth-child(1)": {
      width: "100% !important",
    },
    "& td:nth-child(2), & th:nth-child(2)": {
      width: "200px !important",
      maxWidth: "200px !important",
    },
    "& td:nth-child(3), & th:nth-child(3)": {
      width: "164px !important",
      maxWidth: "164px !important",
      whiteSpace: "nowrap",
    },
    "& td:nth-child(4), & th:nth-child(4)": {
      width: "152px !important",
      maxWidth: "152px !important",
      whiteSpace: "nowrap",
      "& [class*='tableCellIn']": {
        justifyContent: "center",
      },
    },
    "& td": {
      borderTop: `1px solid ${theme.color.gray2}`,
      "&:first-child": {
        borderLeft: `1px solid ${theme.color.gray2}`,
      },
      "&:last-child": {
        borderRight: `1px solid ${theme.color.gray2}`,
      },
    },
    "& [class*='ellipsis']": {
      width: "100%",
    },
  },
  productDesignation: {
    marginBottom: theme.spacing(1),
    display: "block",
  },
  popin: {
    display: "flex",
    flexDirection: "column",
    maxWidth: "50%",
  },
  CircularProgress: {
    flex: 1,
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    backgroundColor: "white",
    alignItems: "center",
    paddingBottom: "calc(var(--fullVh) - 50px)",
  },
}));

export default useStyles;
